import { render } from "./fleet.cattle.io.gitrepo.vue?vue&type=template&id=6a2b22de&scoped=true"
import script from "./fleet.cattle.io.gitrepo.vue?vue&type=script&lang=js"
export * from "./fleet.cattle.io.gitrepo.vue?vue&type=script&lang=js"

import "./fleet.cattle.io.gitrepo.vue?vue&type=style&index=0&id=6a2b22de&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2b22de"]])

export default __exports__